import { useEffect, useRef, useState } from 'react';
import { timeToSeconds } from '../../Player/PlayerServices';
import { ActionBarBtn, ActionBarBtnWrapper } from '../../Player/styles';
import { __t } from '../../../i18n';
import { IconReplay } from '../../../icons';
import UsePlayerProps from '../../../Store/usePlayerProps';

export default function WatchFromStart({ player }: { player: HTMLVideoElement }) {
  const contentConfigs = UsePlayerProps((state) => state.playerState.contentConfigs);
  const [showWatchFromStart, setShowWatchFromStart] = useState<boolean>(false);
  const showStatus = useRef<any>();
  useEffect(() => {
    if (timeToSeconds(contentConfigs?.recommended_start) > 0) {
      handleShowWatchFromStartTimer();
    }
    return () => {
      clearTimeout(showStatus.current);
      showStatus.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentConfigs]);

  const handleShowWatchFromStartTimer = () => {
    if (!showStatus.current && !(player as any)._watchFromStartShown) {
      (player as any)._watchFromStartShown = true;
      setShowWatchFromStart(true);
      showStatus.current = setTimeout(() => {
        setShowWatchFromStart(false);
      }, 20000);
    }
  };
  const handleWatchFromStart = () => {
    if (showWatchFromStart) player.currentTime = 0;
    setShowWatchFromStart(false);
  };
  return (
    <>
      {showWatchFromStart && <ActionBarBtnWrapper onClick={handleWatchFromStart}  marginLeft='1.5rem' marginRight='auto'>
        <ActionBarBtn>
          {__t('player.show_from_beginning')}
          <IconReplay />
        </ActionBarBtn>
      </ActionBarBtnWrapper>
      }
    </>
  );
}
